import React from 'react';
import PageMeta from '../components/common/PageMeta';
import FooterSocial from '../layout/Footer/FooterSocial';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import GetStartedContactsForm from "../components/getStarted/GetStartedContactsForm";
import GetStartedLeftText from "../components/getStarted/GetStartedLeftText";

const Register = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar navDark posAbsolute />
      <section
        className='sign-up-in-section bg-dark ptb-120'
        style={{
          background:
            "url('assets/img/page-header-bg.svg')no-repeat bottom right",
        }}
      >
        <div className='container'>
          <div className='row align-items-center justify-content-between'>
            <GetStartedContactsForm />
            <GetStartedLeftText reqPage/>
          </div>
        </div>
      </section>
      <FooterSocial />
    </Layout>
  );
};

export default Register;
